import Logger from '../../../../../../FrontendBundle/Resources/js/ofcs/logger';
import Warning from './warning';

/**
 * @class SuccessorWarning
 * @extends Warning
 */
export default class SuccessorWarning extends Warning {
    constructor(type, message, icon, items, itemFactory, commandFactory, history) {
        super(type, message, icon, items);
        this.itemFactory = itemFactory;
        this.commandFactory = commandFactory;
        this.history = history;
    }

    solve() {
        const attributes = {
            itemId: this.items[0].get('successorItemId'),
            x: this.items[0].get('position').x,
            y: this.items[0].get('position').y,
            rotation: this.items[0].get('rotation'),
        };

        this.itemFactory
            .create('figure', attributes, this.items[0].getParentItem())
            .then(newItem => this.commandFactory.createSwitchSuccessorCommand(this.items[0], newItem))
            .then(command => this.history.addAndExecuteCommand(command))
            .catch(error => Logger.error(error));
    }
}
